let styledata2 =[
    {
        id : 60,
        imgurl : 'img/section6/section6_5.jpg',
        text : '@k.river.j'
    },
    {
        id : 61,
        imgurl : 'img/section6/section6_6.jpg',
        text : '@weird.co.kr'
    },
    {
        id : 62,
        imgurl : 'img/section6/section6_7.jpg',
        text : '@prettysw_'
    },
    {
        id : 63,
        imgurl : 'img/section6/section6_8.jpg',
        text : '@2m_ariel'
    },
]

export default styledata2;